import styled, { keyframes } from 'styled-components';

export const starAnimation = keyframes`
  0%   { opacity: .0; }
  50%  { opacity: 1; }
  100% { opacity: .0; }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 110px;
  left: 50%;
  transform: translate(-50%, -50%);
  > svg {
    margin-top: 27px;
    &:nth-child(1) {
      bottom: 20px;
      left: -20px;
      position: absolute;
      animation: ${starAnimation} 1.5s infinite;
      animation-delay: 2s;
      animation-fill-mode: backwards;
    }
    &:nth-child(2) {
      bottom: -6px;
      left: 50px;
      position: absolute;
      animation: ${starAnimation} 2s infinite;
      animation-delay: 2s;
      animation-fill-mode: backwards;
    }
  }
`;

export const BgCheck = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  width: 100px;
  height: 100px;
  background: linear-gradient(180deg, #d4fe0f 0%, #93f840 100%);
  opacity: 0.3;
  filter: blur(41.0335px);
  backdrop-filter: blur(41.0335px) opacity(0.3);
`;
